<fuse-vertical-navigation style="box-shadow: 0 4px 6px 2px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);"
  class="bg-gray-200 text-black print:hidden" [appearance]="leftNavigationOpen? 'default':'dense'"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'formNavigation'" [navigation]="leftNavigation"
  [opened]="leftNavigationOpen || !isScreenSmall" [autoCollapse]="false" (openedChanged)="openedChanged.emit($event)">

  <div fuseVerticalNavigationHeader class="flex flex-row fuse-vertical-navigation-header justify-end pr-3">
    <button *ngIf="isScreenSmall" mat-icon-button (click)="leftNavigationOpen =!leftNavigationOpen">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

</fuse-vertical-navigation>